import React from 'react';
import TransportVehicleStore from '../stores/TransportVehicleStore';
import CardDetail from './CardDetail.jsx';
var axios = require('axios');
var constants = require("../constants/constants");

export default class VehicleFillInfo_Show_Details extends React.Component {
    constructor(props) {
        super(props);
        let CompanyId = localStorage.getItem('CompanyId') || 1;
        this.state = {
            isVehicleDetails: false,
            isVehicleInfo: false,
            isEditAction: false,
            VehicleInformation: [],
            vehicledetails: [],
            editVehicleData: null,
            CompanyId: CompanyId,
        };
        this.getVehicleInfo = this.getVehicleInfo.bind(this);
    }

    GetVehicleInformation() {
        var user = JSON.parse(sessionStorage.getItem("User"));
        let currentComponent = this;
        axios.get(constants.config.HOST + constants.api.GET_VEHICLE_INFORMATION, {
            params: { TransportersId: user.TransportersId, CompanyId: localStorage.getItem('CompanyId') || 1, YearId: user.TargetYearId }
        }).then(function (response) {
            currentComponent.setState({ VehicleInformation: response.data })
        }).catch(function (error) {
            console.log(error);
        });

    }

    getVehicleInfo() {
        this.GetVehicleInformation();
    }

    componentWillMount() {
        //   TransportVehicleStore.addListener('vehicles', this.getVehicleInfo)
        this.GetVehicleInformation();
        TransportVehicleStore.addListener('vehicles', this.getVehicleInfo);
    }

    componentWillUnmount() {
        TransportVehicleStore.removeListener('vehicles', this.getVehicleInfo)
    }

    //Button method
    VehicleDetails(e, CompanyId) {
        this.setState({
            isVehicleDetails: true
        });
        this.props.history.push({
            pathname: '/TransportInformation',
            CompanyId: localStorage.getItem('CompanyId') || 1,
        })
    }

    VehicleInfo(e) {
        this.setState({
            isVehicleInfo: true
        });
    }

    editVehicleInfo(e, editVehicleData) {
        e.preventDefault();
        this.setState({
            editVehicleData: editVehicleData
        });
    }

    handleInputChange(e) {
        e.preventDefault();
        var name = e.target.name;
        var state = this.state;
        state[name] = e.target.value;
        this.setState(state);
    }

    render() {
        return (
            <div className="pages">
                <div data-page="form" className="page no-toolbar no-navbar">
                    <div className="page-content">
                        <div className="navbarpages navbarpagesbg">
                            <div className="navbar_left">
                                <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
                            </div>
                            <div className="navbar_right">
                                <a href="/UserProfile" className="external"><img src="images/icons/white/user.png" alt="" title="" /></a>
                            </div>
                        </div>
                        <div id="pages_maincontent">
                            <h3 style={{ 'color': '#0000FF' }}><b style={{ 'padding-left': '80px' }}>वाहनांची  माहिती  </b></h3>
                            <div >
                                <button type="button" className="btn  btn-primary btn-flat" style={{ margin: '5px 0px 5px 245px' }} onClick={(e) => this.VehicleDetails(e, this.props.location.CompanyId)}>माहिती भरा </button>
                            </div>
                            <div>
                                {
                                    (this.state.VehicleInformation !== null || this.state.VehicleInformation !== undefined) ?
                                        this.state.VehicleInformation.map(function (vehicle, index) {
                                            return (
                                                <CardDetail Values={vehicle} vehicle={true} worker={false} mukadam={false} />
                                            )
                                        })
                                        : ''
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

























// WEBPACK FOOTER //
// ./src/component/VehicleFillInfo_Show_Details.jsx